"use client";
import React from "react";
import {useTranslations} from 'next-intl'

interface SloganProps {
}

export function Slogan({}: SloganProps) {
    const t = useTranslations('home.slogan')
    return (
        <div className="bg-[#FFFFFF]">
            <div className="container relative h-[20rem]">
                <div className="items-center flex flex-col justify-between mx-auto w-full h-full py-12 gap-4">
                    <h6 className="text-base md:text-xl items-center text-center justify-center text-blue-600 font-medium flex w-full h-full  ">
                        电信业务营销系统
                    </h6>
                    <h1 className="text-3xl md:text-5xl 2xl:text-5xl items-center justify-center flex font-bold text-foreground dark:text-background/90 w-full h-full ">
                        由 AI 驱动的呼叫中心服务
                    </h1>
                    <h2 className="text-md items-center text-center justify-center text-foreground dark:text-background/80 flex w-full h-full  ">
                        90% 是电话销售的组织模式已经无法适应市场变化，AI+ 带给你新的组织形态，AI 业务流程水线让你用更少人工带来更多收入，促进组织创新业务形态。
                    </h2>
                </div>
            </div>
        </div>
    );
}